"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInvoicesInvoicesStatusFilterEnum = exports.InvoiceApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class InvoiceApi extends runtime.BaseAPI {
    /**
     * Create a credit note from an invoice
     */
    async createCreditNoteRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling createCreditNote.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createCreditNote.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling createCreditNote.');
        }
        if (requestParameters.createCreditNoteRequest === null || requestParameters.createCreditNoteRequest === undefined) {
            throw new runtime.RequiredError('createCreditNoteRequest', 'Required parameter requestParameters.createCreditNoteRequest was null or undefined when calling createCreditNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/credit-note`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CreateCreditNoteRequestToJSON)(requestParameters.createCreditNoteRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Create a credit note from an invoice
     */
    async createCreditNote(requestParameters, initOverrides) {
        const response = await this.createCreditNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the invoice related to the appointment, it is used for the reconciliation invoice system
     * Get the invoice related to the given appointment
     */
    async getAppointmentInvoiceRelatedRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getAppointmentInvoiceRelated.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppointmentInvoiceRelated.');
        }
        if (requestParameters.appointmentId === null || requestParameters.appointmentId === undefined) {
            throw new runtime.RequiredError('appointmentId', 'Required parameter requestParameters.appointmentId was null or undefined when calling getAppointmentInvoiceRelated.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/appointments/{appointmentId}/get-invoice-related`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"appointmentId"}}`, encodeURIComponent(String(requestParameters.appointmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetAppointmentInvoiceRelated200ResponseFromJSON)(jsonValue));
    }
    /**
     * Returns the invoice related to the appointment, it is used for the reconciliation invoice system
     * Get the invoice related to the given appointment
     */
    async getAppointmentInvoiceRelated(requestParameters, initOverrides) {
        const response = await this.getAppointmentInvoiceRelatedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get an invoice
     */
    async getInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling getInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetInvoice200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get an invoice
     */
    async getInvoice(requestParameters, initOverrides) {
        const response = await this.getInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get an invoice preview (used for UBP)
     */
    async getInvoicePreviewRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoicePreview.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling getInvoicePreview.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/preview`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetInvoicePreview200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get an invoice preview (used for UBP)
     */
    async getInvoicePreview(requestParameters, initOverrides) {
        const response = await this.getInvoicePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a valid invoice URL
     */
    async getInvoiceUrlRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoiceUrl.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceUrl.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/url`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetInvoiceUrl200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a valid invoice URL
     */
    async getInvoiceUrl(requestParameters, initOverrides) {
        const response = await this.getInvoiceUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the paginated data from invoices
     * Get the invoices list
     */
    async getInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getInvoices.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoices.');
        }
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit', 'Required parameter requestParameters.limit was null or undefined when calling getInvoices.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.cursorId !== undefined) {
            queryParameters['cursorId'] = requestParameters.cursorId;
        }
        if (requestParameters.invoicesStatusFilter !== undefined) {
            queryParameters['invoicesStatusFilter'] = requestParameters.invoicesStatusFilter;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetInvoices200ResponseFromJSON)(jsonValue));
    }
    /**
     * Returns the paginated data from invoices
     * Get the invoices list
     */
    async getInvoices(requestParameters, initOverrides) {
        const response = await this.getInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of invocies by status
     * Get the invocies count
     */
    async getInvoicesCountRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getInvoicesCount.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoicesCount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/count`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetInvoicesCount200ResponseFromJSON)(jsonValue));
    }
    /**
     * Returns the count of invocies by status
     * Get the invocies count
     */
    async getInvoicesCount(requestParameters, initOverrides) {
        const response = await this.getInvoicesCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get invoices with sync QuickBooks issues
     */
    async getInvoicesWithSyncQuickBooksIssuesRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInvoicesWithSyncQuickBooksIssues.');
        }
        if (requestParameters.realmIdInPath === null || requestParameters.realmIdInPath === undefined) {
            throw new runtime.RequiredError('realmIdInPath', 'Required parameter requestParameters.realmIdInPath was null or undefined when calling getInvoicesWithSyncQuickBooksIssues.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/realm/{realmIdInPath}/invoices-with-sync-quickbooks-issues`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"realmIdInPath"}}`, encodeURIComponent(String(requestParameters.realmIdInPath))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.GetInvoicesWithSyncQuickBooksIssues200ResponseInnerFromJSON));
    }
    /**
     * Get invoices with sync QuickBooks issues
     */
    async getInvoicesWithSyncQuickBooksIssues(requestParameters, initOverrides) {
        const response = await this.getInvoicesWithSyncQuickBooksIssuesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Links a package instance to an invoice and updates the Stripe invoice metadata
     * Link a package instance to an invoice
     */
    async linkPackageInstanceToInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling linkPackageInstanceToInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling linkPackageInstanceToInvoice.');
        }
        if (requestParameters.linkPackageInstanceToInvoiceRequest === null || requestParameters.linkPackageInstanceToInvoiceRequest === undefined) {
            throw new runtime.RequiredError('linkPackageInstanceToInvoiceRequest', 'Required parameter requestParameters.linkPackageInstanceToInvoiceRequest was null or undefined when calling linkPackageInstanceToInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/link-package-instance`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.LinkPackageInstanceToInvoiceRequestToJSON)(requestParameters.linkPackageInstanceToInvoiceRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Links a package instance to an invoice and updates the Stripe invoice metadata
     * Link a package instance to an invoice
     */
    async linkPackageInstanceToInvoice(requestParameters, initOverrides) {
        const response = await this.linkPackageInstanceToInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Mark an invoice as paid
     */
    async markInvoiceAsPaidRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling markInvoiceAsPaid.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling markInvoiceAsPaid.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/mark-as-paid`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Mark an invoice as paid
     */
    async markInvoiceAsPaid(requestParameters, initOverrides) {
        const response = await this.markInvoiceAsPaidRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Mark an invoice as shared
     */
    async markInvoiceAsSharedRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling markInvoiceAsShared.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling markInvoiceAsShared.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/mark-as-shared`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.MarkInvoiceAsSharedRequestToJSON)(requestParameters.markInvoiceAsSharedRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Mark an invoice as shared
     */
    async markInvoiceAsShared(requestParameters, initOverrides) {
        const response = await this.markInvoiceAsSharedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Move invoice billing transaction to a different invoice
     */
    async moveInvoiceBillingTransactionsRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling moveInvoiceBillingTransactions.');
        }
        if (requestParameters.billingTransactionId === null || requestParameters.billingTransactionId === undefined) {
            throw new runtime.RequiredError('billingTransactionId', 'Required parameter requestParameters.billingTransactionId was null or undefined when calling moveInvoiceBillingTransactions.');
        }
        if (requestParameters.moveInvoiceBillingTransactionsRequest === null || requestParameters.moveInvoiceBillingTransactionsRequest === undefined) {
            throw new runtime.RequiredError('moveInvoiceBillingTransactionsRequest', 'Required parameter requestParameters.moveInvoiceBillingTransactionsRequest was null or undefined when calling moveInvoiceBillingTransactions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/billing-transactions/{billingTransactionId}/move`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"billingTransactionId"}}`, encodeURIComponent(String(requestParameters.billingTransactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.MoveInvoiceBillingTransactionsRequestToJSON)(requestParameters.moveInvoiceBillingTransactionsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Move invoice billing transaction to a different invoice
     */
    async moveInvoiceBillingTransactions(requestParameters, initOverrides) {
        const response = await this.moveInvoiceBillingTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Processes payment for an invoice using the specified payment method. This operation will: - Validate that the organization has a Stripe account configured - Verify the invoice is not already paid - Process the payment through Stripe - Update the invoice status to paid - Update subscription payment method if applicable
     * Pay an invoice
     */
    async payInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling payInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling payInvoice.');
        }
        if (requestParameters.payInvoiceRequest === null || requestParameters.payInvoiceRequest === undefined) {
            throw new runtime.RequiredError('payInvoiceRequest', 'Required parameter requestParameters.payInvoiceRequest was null or undefined when calling payInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/pay`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PayInvoiceRequestToJSON)(requestParameters.payInvoiceRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Processes payment for an invoice using the specified payment method. This operation will: - Validate that the organization has a Stripe account configured - Verify the invoice is not already paid - Process the payment through Stripe - Update the invoice status to paid - Update subscription payment method if applicable
     * Pay an invoice
     */
    async payInvoice(requestParameters, initOverrides) {
        const response = await this.payInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Approve an invoice
     */
    async postApproveInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling postApproveInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling postApproveInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/approve`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Approve an invoice
     */
    async postApproveInvoice(requestParameters, initOverrides) {
        const response = await this.postApproveInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel an invoice
     */
    async postCancelInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling postCancelInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling postCancelInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/cancel`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Cancel an invoice
     */
    async postCancelInvoice(requestParameters, initOverrides) {
        const response = await this.postCancelInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Unapprove an invoice
     */
    async postUnapproveInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling postUnapproveInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling postUnapproveInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/unapprove`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Unapprove an invoice
     */
    async postUnapproveInvoice(requestParameters, initOverrides) {
        const response = await this.postUnapproveInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Recompute invoice billing transactions
     */
    async recomputeInvoiceBillingTransactionsRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling recomputeInvoiceBillingTransactions.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling recomputeInvoiceBillingTransactions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/recompute`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Recompute invoice billing transactions
     */
    async recomputeInvoiceBillingTransactions(requestParameters, initOverrides) {
        const response = await this.recomputeInvoiceBillingTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a refund amount from an invoice
     */
    async refundInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling refundInvoice.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling refundInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling refundInvoice.');
        }
        if (requestParameters.refundInvoiceRequest === null || requestParameters.refundInvoiceRequest === undefined) {
            throw new runtime.RequiredError('refundInvoiceRequest', 'Required parameter requestParameters.refundInvoiceRequest was null or undefined when calling refundInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/refund`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.RefundInvoiceRequestToJSON)(requestParameters.refundInvoiceRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Create a refund amount from an invoice
     */
    async refundInvoice(requestParameters, initOverrides) {
        const response = await this.refundInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Resolve QuickBooks sync-failed activity logs for an invoice
     */
    async resolveQuickBooksSyncFailedActivityLogsRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling resolveQuickBooksSyncFailedActivityLogs.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling resolveQuickBooksSyncFailedActivityLogs.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/resolve-quickbooks-sync-failed`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Resolve QuickBooks sync-failed activity logs for an invoice
     */
    async resolveQuickBooksSyncFailedActivityLogs(requestParameters, initOverrides) {
        const response = await this.resolveQuickBooksSyncFailedActivityLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Sync an invoice with stripe
     */
    async syncInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling syncInvoice.');
        }
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling syncInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invoices/{invoiceId}/sync`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Sync an invoice with stripe
     */
    async syncInvoice(requestParameters, initOverrides) {
        const response = await this.syncInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.InvoiceApi = InvoiceApi;
/**
  * @export
  * @enum {string}
  */
var GetInvoicesInvoicesStatusFilterEnum;
(function (GetInvoicesInvoicesStatusFilterEnum) {
    GetInvoicesInvoicesStatusFilterEnum["All"] = "all";
    GetInvoicesInvoicesStatusFilterEnum["Succeeded"] = "succeeded";
    GetInvoicesInvoicesStatusFilterEnum["Shared"] = "shared";
    GetInvoicesInvoicesStatusFilterEnum["Failed"] = "failed";
    GetInvoicesInvoicesStatusFilterEnum["Attention"] = "attention";
    GetInvoicesInvoicesStatusFilterEnum["Refunded"] = "refunded";
})(GetInvoicesInvoicesStatusFilterEnum || (exports.GetInvoicesInvoicesStatusFilterEnum = GetInvoicesInvoicesStatusFilterEnum = {}));
//# sourceMappingURL=InvoiceApi.js.map